module.exports = __webpack_public_path__ + "img/study-mode-faq-3.7a79839e.png";